import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import './i18n/i18n';

// No token bootstrap on startup: auth is a cookie-based backend session
// (see CB25SES-1197/1198/1206 and utils/apiClient.ts) established via a
// browser redirect through /login or /auth/login, not minted on app load.

// Suppress Material-UI v4 + React Router v6 compatibility warning in development
// This is a known issue with Material-UI v4.12.2 using deprecated React APIs (findDOMNode)
// Will be resolved in Phase 2 when upgrading to Material-UI v5
if (process.env.NODE_ENV === 'development') {
  /* eslint-disable no-console -- intentional dev-only patch of console.warn */
  const originalWarn = console.warn;
  console.warn = (...args: any[]) => {
    const message = String(args[0]);
    if (
      message.includes('findDOMNode') &&
      message.includes('react-router-dom')
    ) {
      return; // Suppress known Material-UI v4 compatibility warning
    }
    originalWarn(...args);
  };
  /* eslint-enable no-console */
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
